module.exports = __webpack_public_path__ + "img/制御工学2_7.e898282e.png";